import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import { callAPI } from "../../App/Helpers/callApi";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import DropdownComponent from "../../App/Components/Dropdown/DropdownComponent";
import { editEventSearch, getEventSearch } from "./EventSearchService";
import { CheckRoleForClient } from "../../App/Helpers/PermissionsChecks";
import { Roles } from "../../App/Enums/Roles";
import { selectUserPermissionsValue } from "../../App/State/Slices/UserPermissionsSlice";

function EventSearchPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const rolesObject = useSelector(selectUserPermissionsValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [display, setDisplay] = useState(false);

  function saveEventSearch() {
    let data = {
      ClientId: selectCareersClient.id,
      templateId: selectedTemplate.id,
      IsDisplayed: display,
    };

    callAPI(
      editEventSearch(data),
      "Event Search Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventSearch(selectCareersClient.id).then((response) => {
        setTemplates(response.templates);
        setDisplay(response.isDisplayed);
      });
    });
  }

  useEffect(() => {
    if (selectCareersClient !== null) {
      getEventSearch(selectCareersClient.id).then((response) => {
        response.templates.push({ name: "None", id: "" });
        setTemplates(response.templates);
        setDisplay(response.isDisplayed);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Event Search
        </h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  {CheckRoleForClient(
                    rolesObject,
                    selectCareersClient.id?.toUpperCase(),
                    Roles.SuperAdmin
                  ) ? (
                    <Grid item xs={12} sm={6}>
                      <DropdownComponent
                        currValue={selectedTemplate}
                        items={templates}
                        property="name"
                        title="Assign To Template"
                        handleChange={(value) => setSelectedTemplate(value)}
                      />
                    </Grid>
                  ) : null}
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      className={classes.copy}
                      style={{ marginTop: "10px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={display}
                          onChange={() => setDisplay(!display)}
                        />
                      }
                      label="Display Search Form"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => saveEventSearch()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default EventSearchPage;
